import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import {
  CONFIRMATION_DIALOG_ID,
  ConfirmationDialogComponent,
  ConfirmationDialogData,
} from './confirmation-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService extends AbstractDialogService<
  ConfirmationDialogData,
  boolean,
  typeof ConfirmationDialogComponent
> {
  override readonly id = CONFIRMATION_DIALOG_ID;
  protected override readonly component = ConfirmationDialogComponent;

  override async openDialog(params?: { input?: ConfirmationDialogData }): Promise<boolean | undefined> {
    return super.openDialog({
      options: {
        componentProps: {
          title: params?.input?.title ?? '',
          message: params?.input?.message ?? '',
          confirmLabel: params?.input?.confirmLabel ?? 'Confirm',
          cancelLabel: params?.input?.cancelLabel ?? 'Cancel',
          confirmColor: params?.input?.confirmColor ?? 'red',
        },
      },
    });
  }
}
